<template>
  <v-row>
    <v-col :cols="primaryServiceSize">
          <gg-card class="fill-height">
            <gg-card-header>
              Primary Reference
            </gg-card-header>
          <v-card-text>
            {{ decodeHtmlCharCodes(filteredServices.primary_service.value) }}
          </v-card-text>
        </gg-card>
    </v-col>
    <v-col v-if="isAddonsAvailable" :cols="primaryServiceSize">
      <gg-card class="fill-height">
        <gg-card-header>
          Cancellation Items
        </gg-card-header>
        <v-card-text>
          <p
            v-for="(service, index) in filteredServices.cancel_service"
            :key="index"
          >
            {{ decodeHtmlCharCodes(service.value) }}
          </p>
        </v-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { decodeHtmlCharCodes } from 'Helpers/helpers'

export default {
  name: 'CancellationServices',
  props: {
    cr_services: {
      type: Array,
      required: true,
      default: () => ([])
    },
  },
  data: () => ({
    decodeHtmlCharCodes
  }),
  computed: {
    ...mapGetters(['cancellation']),
    filteredServices () {
      let result = {
        primary_service: {},
        cancel_service: []
      }

      this.cancellation.services.map(item => {
        if (item.type === 'primary') {
          result.primary_service = {
            type: item.type,
            value: `${item.product} - ${item.domain}`
          }
        } else {
          result.cancel_service.push({
            type: 'cancel',
            value: `${item.product} - ${item.domain}`
          })
        }
      })
      return result
    },
    isAddonsAvailable () {
      return this.filteredServices.cancel_service.length !== 0
    },
    primaryServiceSize () {
      return this.isAddonsAvailable ? 6 : 12
    }
  },
}
</script>
